import { I18nProvider } from 'providers/I18nProvider'
import { StoreProvider } from 'providers/StoreProvider'
import { QueryProvider } from 'providers/QueryProvider'
import { ThemeProvider } from 'providers/ThemeProviders'
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router'
import { WidgetPage } from 'pages/WidgetPage'
import { ChatPage } from 'pages/ChatPage'
import { ModalProvider } from 'providers/ModalProvider'
import { TenantProvider } from 'providers/TenantProvider'
import 'react-toastify/dist/ReactToastify.css'
import { AuthBootstrapProvider } from 'providers/AuthBootstrapProvider'
import { useDocumentMeta } from 'hooks/useDocumentMeta'
import { useCookieConsentBootstrap } from 'hooks/useCookieConsentBootstrap'
import { PrivacyPolicyPage, CookiePolicyPage } from 'pages/PolicyPage'

const DocumentMeta = () => {
  useDocumentMeta()
  useCookieConsentBootstrap()
  return null
}

export const App = () => {
  const routes: RouteObject[] = [
    {
      path: '/',
      element: <WidgetPage />,
    },
    {
      path: '/chat',
      element: <ChatPage />,
    },
    {
      path: '/chat/:chatId',
      element: <ChatPage />,
    },
    {
      path: '/privacy-policy',
      element: <PrivacyPolicyPage />,
    },
    {
      path: '/cookie-policy',
      element: <CookiePolicyPage />,
    },
    {
      path: '*',
      element: <WidgetPage />,
    },
  ]

  const router = createBrowserRouter(routes)

  return (
    <I18nProvider>
      <StoreProvider>
        <TenantProvider>
          <QueryProvider>
            <ThemeProvider>
              <AuthBootstrapProvider>
                <ModalProvider>
                  <DocumentMeta />
                  <RouterProvider router={router} />
                </ModalProvider>
              </AuthBootstrapProvider>
            </ThemeProvider>
          </QueryProvider>
        </TenantProvider>
      </StoreProvider>
    </I18nProvider>
  )
}
